<template>
  <div class="body">
    <div class="detay">
      <div class="sayfabaslik">
        <div class="text">
          <div class="el-button-group">
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/alacak" type="default"> Alacak Listesi
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/borc" type="default"> Borc Listesi
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/kisi" type="default"> Kişi Ekstresi
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/cari" type="default"> Cari Ekstresi
            </router-link>
            <el-dropdown @command="link">
              <el-button
                :type="this.$route.path[11]+this.$route.path[12]+this.$route.path[13]+this.$route.path[14]=='kasa'?'primary':''"
                size="small">
                Kasa Raporu
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/raporlama/kasa/gelir">Kasa Gelir Raporu</el-dropdown-item>
                <el-dropdown-item command="/raporlama/kasa/gider">Kasa Gider Raporu</el-dropdown-item>
                <el-dropdown-item command="/raporlama/kasa/ekstre">Kasa Ekstre</el-dropdown-item>
                <el-dropdown-item command="/raporlama/kasa/bilanco">Kasa Bilanço</el-dropdown-item>
                <el-dropdown-item command="/raporlama/kasa/aylik">Aylık Bilanço</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="link">
              <el-button
                :type="this.$route.path[11]+this.$route.path[12]+this.$route.path[13]+this.$route.path[14]=='ozel'?'primary':''"
                size="small">
                Özel Raporlar
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/raporlama/ozel/defter">İşletme Defteri</el-dropdown-item>
                <el-dropdown-item command="/raporlama/ozel/gunsonu">Gün Sonu</el-dropdown-item>
                <!--el-dropdown-item command="/raporlama/ozel/denetci">Denetçi Raporları</el-dropdown-item-->
                <el-dropdown-item command="/raporlama/ozel/hazirun">Hazirun Cetveli</el-dropdown-item>
                <el-dropdown-item command="/raporlama/ozel/kisi">Kişi Listesi</el-dropdown-item>
                <el-dropdown-item command="/raporlama/ozel/makbuz">Makbuz Arama</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="link">
              <el-button
                :type="this.$route.path[11]+this.$route.path[12]+this.$route.path[13]+this.$route.path[14]=='icra'?'primary':''"
                size="small">
                İcra Raporu
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/raporlama/icra/dosya">İcra Dosyaları</el-dropdown-item>
                <el-dropdown-item command="/raporlama/icra/gecikmis">Gecikmiş Alacaklar</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/sayac" type="default"> Sayaç Raporu
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/banka" type="default"> Banka Ekstresi
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/webpos" type="default"> Web Pos Raporu
            </router-link>
            <router-link tag="el-button" class="el-button--small" active-class="el-button--primary"
                         to="/raporlama/santral" type="default"> Santral Raporu
            </router-link>
          </div>
        </div>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {

  methods: {
    link(url) {
      this.$router.push(url);
    }
  }
}
</script>

<style scoped>
.el-button-group .el-dropdown {
  float: left;
}

.el-button-group .el-dropdown .el-button {
  border-radius: 0 !important;
  margin-right: -1px;
  border-left-color: #DCDFE6;
}
</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/_route.vue